(() => {
  const MIN_SHARP_POSTER_WIDTH = 640;

  const getYoutubeId = (deferredMedia) => {
    const iframe = deferredMedia.querySelector('template')?.content.querySelector('iframe.js-youtube');
    if (!iframe) return null;

    try {
      const pathParts = new URL(iframe.src).pathname.split('/').filter(Boolean);
      return pathParts.at(-1) || null;
    } catch (error) {
      return null;
    }
  };

  const loadImage = (url) =>
    new Promise((resolve) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => resolve(null);
      image.src = url;
    });

  const findSharpPoster = async (videoId) => {
    const candidates = ['maxresdefault', 'sddefault'];

    for (const candidate of candidates) {
      const url = `https://i.ytimg.com/vi/${encodeURIComponent(videoId)}/${candidate}.jpg`;
      const image = await loadImage(url);
      if (image?.naturalWidth >= MIN_SHARP_POSTER_WIDTH) return url;
    }

    return null;
  };

  const improvePoster = async (deferredMedia) => {
    if (deferredMedia.dataset.sharpYoutubePoster === 'pending') return;

    const videoId = getYoutubeId(deferredMedia);
    if (!videoId) return;

    deferredMedia.dataset.sharpYoutubePoster = 'pending';
    const sharpPoster = await findSharpPoster(videoId);

    if (sharpPoster) {
      const mediaContainer = deferredMedia.closest('.media-type-external_video');
      const posterImages = mediaContainer
        ? mediaContainer.querySelectorAll('.product__media img, .deferred-media__poster img')
        : deferredMedia.querySelectorAll('.deferred-media__poster img');

      posterImages.forEach((image) => {
        image.src = sharpPoster;
        image.srcset = `${sharpPoster} 1280w`;
        image.width = 1280;
        image.height = 720;
      });
    }

    deferredMedia.dataset.sharpYoutubePoster = sharpPoster ? 'ready' : 'unavailable';
  };

  const improveAllPosters = (root = document) => {
    root.querySelectorAll('deferred-media').forEach(improvePoster);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => improveAllPosters());
  } else {
    improveAllPosters();
  }

  document.addEventListener('shopify:section:load', (event) => improveAllPosters(event.target));
})();
